import React, { useEffect } from 'react';

export function AuthCallbackPage() {
  useEffect(() => {
    // Supabase automatically processes the OAuth callback via detectSessionInUrl: true
    // We just need to wait for the session to be established and then redirect to the app.
    const timer = setTimeout(() => {
      window.location.href = '/app';
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      background: '#0F0E0D',
      color: '#F5F2EC',
      gap: 16,
    }}>
      <svg width="60" height="60" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(60,60)">
          <rect x="-30" y="-20" width="20" height="40" rx="3" fill="#FF5A4E"/>
          <rect x="-36" y="-20" width="32" height="9" rx="3" fill="#FF5A4E"/>
          <rect x="6" y="-22" width="20" height="40" rx="3" fill="#FFB627"/>
          <rect x="0" y="-22" width="32" height="9" rx="3" fill="#FFB627"/>
        </g>
      </svg>
      <p style={{ fontSize: 14, color: '#A19B8F' }}>Logger dig ind...</p>
    </div>
  );
}
